(function() {
    function isInquiryButton(element) {
        if (!element || !element.dataset || !element.dataset.id) return false;
        const isClickable = element.tagName === 'BUTTON' ||
                           element.tagName === 'A' ||
                           element.getAttribute('role') === 'button' ||
                           element.onclick !== null;
        const hasInquiryAttributes = element.classList.contains('inquire_form_btn') ||
                                    element.dataset.title ||
                                    element.dataset.sku ||
                                    element.dataset.image;
        return isClickable && hasInquiryAttributes;
    }

    document.addEventListener('click', function(e) {
        let button = null;
        let element = e.target;
        while (element && element !== document.body) {
            if (isInquiryButton(element)) {
                button = element;
                break;
            }
            element = element.parentElement;
        }

        if (!button) return;

        const product = {
            id: button.dataset.id,
            title: button.dataset.title || '',
            image: button.dataset.image || '',
            sku: button.dataset.sku || '',
            quantity: parseInt(button.dataset.quantity) || 1,
            url: button.dataset.url || window.location.href
        };

        if (!product.id) return;

        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        if (button.tagName === 'A' && button.href) {
            const originalHref = button.href;
            button.href = 'javascript:void(0)';
            setTimeout(() => {
                if (button.href === 'javascript:void(0)') {
                    button.href = originalHref;
                }
            }, 100);
        } else if (button.tagName === 'BUTTON') {
            if (button.type === 'submit' || !button.type) {
                button.type = 'button';
            }
            const form = button.closest('form');
            if (form) {
                form.addEventListener('submit', function(evt) {
                    evt.preventDefault();
                    evt.stopPropagation();
                }, { once: true, capture: true });
            }
        }

        document.dispatchEvent(new CustomEvent('addToInquiry', {
            detail: product,
            bubbles: true,
            cancelable: true
        }));
    }, true);
})();
